import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { faLockOpen, faLock, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { DxDataGridComponent } from "devextreme-angular";
import { UserService } from '../../../../shared/services/user.service';
import { EmployeePortalService } from '../../_api/services/employee-portal.service';
import { LanguageService } from '../../../../shared/services/language.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-employee-list-balance',
  templateUrl: './employee-list-balance.component.html',
  styleUrls: ['./employee-list-balance.component.css']
})
export class EmployeeListBalanceComponent implements OnInit, OnChanges {

  @ViewChild(DxDataGridComponent, {static: false}) dataGrid: DxDataGridComponent;
  @Input() selectedEmployeeId: number = -1;
  @Input() showEmployeeSelect: boolean = true;
  @Input() showEmployeeColumn: boolean = true;
  @Input() employeeDataSource: any[];
  dataSource: any;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(employee-portal.component) to show load indicator
  from: string;
  to: string;
  placeholderEmployeeSelect = "";
  faLockOpen = faLockOpen;
  faLock = faLock;
  faEnvelope = faEnvelope;
  statusFilterData = [];
  selectedEmployeeIdFromGrid: number = -1;//the employeeid of the clicked gridrow
  selectedBalanceIdFromGrid: number = -1;//the balance of the clicked gridrow
  detailMenu: any;
  menuIndex: number = 0;
  tabDataSource: any[];
  tabSelectedIndex: number = 0;
  selectedDetail: any;
  detailVisible: boolean = false;

  faTimes = faTimes;

  constructor(private userService: UserService, private employeePortalService: EmployeePortalService, public languageService: LanguageService) {
   }

  ngOnInit() {
    this.from = moment().format("DD.MM.YYYY");
    this.to = moment().format("DD.MM.YYYY");
    this.placeholderEmployeeSelect = this.languageService.LNG("Label.Employee");
    this.statusFilterData = [];
    this.tabDataSource = [
      { id: {}, title: this.languageService.LNG('Label.Overview') }
    ];

    this.loadBalances(true);
  }

  ngOnChanges() {
    this.tabDataSource = [
      { id: {}, title: this.languageService.LNG('Label.Overview') }
    ];
    this.tabSelectedIndex = 0;
    this.loadBalances(true);
  }

  loadBalances(refreshSearchCriterias: boolean = true) {
    this.loading.emit(true);
    let user = this.userService.account;
    this.employeePortalService.getListBalances(this.selectedEmployeeId, user.IsSupervisor)
      .subscribe((result: any) => { // success path
        this.dataSource = result.Data;
        this.loading.emit(false);
        if (refreshSearchCriterias) {
          this.clearDataGridSelections();
        }
      }, error => { // error path;
        this.loading.emit(false);
      });
  }

  clearDataGridSelections() {
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearGrouping();
    this.dataGrid.instance.clearSelection();
    this.dataGrid.instance.clearSorting();
  }

  //show grouped date as "dddd DD.MM.YYYY". the date from dataField has format DD.MM.YYYY
  groupTemplate(data) {


    let date = data.value;
    // let dt = moment(date);
    let dt = moment(date, "YYYY-MM-DD");
    console.log("dt", dt);
    var nb = moment(dt).locale('nb');
    let dateDDMMYYYY = nb.format('dddd DD.MM.YYYY');
    return dateDDMMYYYY;
  }

  //sort datestring as date
  customDateSort (rowData) {
    return rowData.Date;
  }

  onSelectionChangedEmployees(e) {

    if (e.selectedItem) {
      this.selectedEmployeeId = e.selectedItem.EmployeeId;
    }
    else {
      this.selectedEmployeeId = -1;
    }
    this.loadBalances(false);
  }

  onCellClick(e: any) {
      if (e.column.dataField !== undefined) {
        this.selectedEmployeeIdFromGrid = e.key.EmployeeId;
        this.selectedBalanceIdFromGrid = e.key.BalanceId;
        for (let i = 0; i < this.tabDataSource.length; i++) {
          let tab = this.tabDataSource[i];
          if (e.key.EmployeeId === tab.id.EmployeeId && e.key.BalanceId == tab.id.BalanceId) {
            this.tabSelectedIndex = i;
            this.detailVisible = true;
            return;
          }
        }
        let tabIdx = this.tabDataSource.length;
        if (e.key.TabTitle !== undefined) {
          this.tabDataSource.push({ id: e.key, title: e.key.TabTitle, tabIdx: tabIdx });
        }
        else if (e.key.Code !== undefined) {
          this.tabDataSource.push({ id: e.key, title: e.key.Code, tabIdx: tabIdx });
        } else {
          this.tabDataSource.push({ id: e.key, title: e.key.EmployeeName + " - " + e.key.BalanceCode, tabIdx: tabIdx });
        }
        this.tabSelectedIndex = this.tabDataSource.length - 1;
        this.detailVisible = true;
      }
  }

  onTitleClick(e) {
    this.tabSelectedIndex = e.itemIndex;
    if (e.itemIndex === 0) {
      this.menuIndex = 0;
      this.detailVisible = false;
    } else {
      this.detailVisible = true;
      this.selectedEmployeeIdFromGrid = e.itemData.id.EmployeeId;
      this.selectedBalanceIdFromGrid = e.itemData.id.BalanceId;
    }
  }

  onTabTemplateClick(data: any) {
      this.selectedDetail = null;
      for (let i = 0; i < this.tabDataSource.length; i++) {
        let tab: any = this.tabDataSource[i];
        if (tab.id.EmployeeId !== undefined && tab.id.BalanceId !== undefined && data.EmployeeId === tab.id.EmployeeId && data.BalanceId === tab.id.BalanceId) {
          return;
        }
      }
      if (data.EmployeeId !== undefined && data.BalanceId !== undefined) {
        let tabIdx = this.tabDataSource.length;
        this.tabDataSource.push({ id: data, title: data.EmployeeName + " - " + data.BalanceCode, tabIdx: tabIdx });
      }
  }

  onCloseTabClicked(tab) {
    let tabindex = this.tabDataSource.findIndex(obj => {
      return obj.id.EmployeeId === tab.id.EmployeeId && obj.id.BalanceId === tab.id.BalanceId
    })
    this.tabDataSource.splice(tabindex, 1);
    let tabIdx = this.tabDataSource.length - 1;
    if (tabIdx > 0) {
      this.tabSelectedIndex = this.tabDataSource.length - 1;
      this.selectedDetail = this.tabDataSource[this.tabSelectedIndex].id;
      this.detailVisible = true;
      this.selectedEmployeeIdFromGrid = this.selectedDetail.EmployeeId;
      this.selectedBalanceIdFromGrid = this.selectedDetail.BalanceId;
    } else {
      this.tabSelectedIndex = 0;
      this.detailVisible = false;
    }
  }

  onCloseTab() {
    if (this.tabSelectedIndex !== 0) {
      this.tabDataSource.splice(this.tabSelectedIndex, 1);
      let tabIdx = this.tabDataSource.length - 1;
      if (tabIdx > 0) {
        this.tabSelectedIndex = this.tabDataSource.length - 1;
        this.selectedDetail = this.tabDataSource[this.tabSelectedIndex].id;
        this.detailVisible = true;
        this.selectedEmployeeIdFromGrid = this.selectedDetail.EmployeeId;
        this.selectedBalanceIdFromGrid = this.selectedDetail.BalanceId;
      } else {
        this.tabSelectedIndex = 0;
        this.detailVisible = false;
        // if (this.timeTypeIsAdding) {
        //   // add is canceled/not saved, remove record from grid
        //   for (let i = 0; i < this.timeTypeGridRecords.length; i++) {
        //     if (this.timeTypeGridRecords[i].TimeTypeId === -1) {
        //       this.timeTypeGridRecords.splice(i, 1);
        //       this.timeTypeIsAdding = false;
        //       break;
        //     }
        //   }
        // }
      }
    }
  }

  onLoadingDetail(loading: boolean) {
    this.loading.emit(loading);
  }

}
